module Meevo.Components.Common {
    export class DurationIncrementsService {
        constructor(private dataService: Meevo.Components.BaseClasses.IDataService,
            private $q: ng.IQService,
            private $rootScope) {

        }

        appointmentBookIncrement;
        getIncrements(maxMinutes: number, includeZero: boolean) {
            if (this.$rootScope.appointmentBookIncrement) {
                this.appointmentBookIncrement = this.$rootScope.appointmentBookIncrement;
            }
            let deferred = this.$q.defer();
            if (!this.appointmentBookIncrement) {
                this.dataService.customMethodData(`/api/Tenant/BusinessInfo/Settings`, "get", null).then(response => {
                    switch (response.data.appointmentBookSettings.appointmentBookIncrement) {
                        case Meevo.Model.AppointmentIncrementEnum.Min5:
                            this.appointmentBookIncrement = 5;
                            break;
                        case Meevo.Model.AppointmentIncrementEnum.Min10:
                            this.appointmentBookIncrement = 10;
                            break;
                        case Meevo.Model.AppointmentIncrementEnum.Min15:
                            this.appointmentBookIncrement = 15;
                            break;
                    };
                    deferred.resolve(this.buildIncrements(maxMinutes, includeZero));
                });
            } else {
                deferred.resolve(this.buildIncrements(maxMinutes, includeZero));
            }
            return deferred.promise;
        }      

        private buildIncrements(maxMinutes: number, includeZero:boolean) 
        {
            let increments = [];
            let startIndex = includeZero ? 0 : 1;
            let numberOfIncrements = maxMinutes / this.appointmentBookIncrement;
            for (var i = startIndex; i <= numberOfIncrements; i++) {
                increments.push(this.appointmentBookIncrement * i);
            }
            return increments;
        }

        static factory(): Function {
            let svc = (dataService: Meevo.Components.BaseClasses.IDataService, $q: ng.IQService, $rootScope) => {
                return new DurationIncrementsService(dataService, $q, $rootScope);
            }

            svc.$inject = ["meevo.components.common.DataService", "$q", "$rootScope"];
            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.durationIncrementsService", DurationIncrementsService.factory());
}